module.exports = {
  title: '推荐汽车品牌',
  route: {
    path: '/content-manage',
    children: {
      path: 'recommend-carbrand-manage',
    },
  },
};
